/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {
    list: [],
};

export default function areasReducer(state = INITIALSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.SET_DISTRICTS:
            st = cloneState(state);
            st.list = action.payload;
            return st;
        default:
            return st;
    }
}
